import React from 'react'
import moment from 'moment';
import LoadingSpinner from "../components/LoadingSpinner";
import Row from '../components/Row'
import NoRecordsFound from '../components/NoRecordsFound';
import { getEnvironmentShort } from '../../../util/helpers';

const ScenariosList = ({ scenarios, selectedScenario, onEdit, onDelete, onClick, onSortBy, sortBy, isSortAsc, isLoading }) => {
    const headers = [
        {
          key: "name",
          name: "Name",
          width: 4
        },
        {
          key: "environment",
          name: "Environment",
          width: 2
        },
        {
          key: "creationTime",
          name: "Age",
          width: 2
        },
        {
          key: "lastUpdateTime",
          name: "Last Update",
          width: 2
        },
        {
          key: "edit",
          name: "Edit",
          sortable: false,
          width: 1
        },
        {
          key: "delete",
          name: "Delete",
          sortable: false,
          width: 1
        }
    ]
    
    const arrow = isSortAsc ? <span className="glyphicon glyphicon-triangle-bottom" title="Active" /> :  <span className="glyphicon glyphicon-triangle-top" title="Inactive" />

    const renderTableHeaders = () => {
        return headers.map(({ key, name, width, sortable }) => {
            if (sortable === false) {
                return (
                    <th key={key}>
                        <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                    </th>
                )
            }

            return (
                <th key={key}  onClick={() => onSortBy(key)}>
                    <div className={`text-center table-header table-header-clickable col-sm-${width}`} >
                        {name} {sortBy === key && arrow }
                    </div>
                </th>
            )
        })
    }

    const renderTableRows = () => {
        if (scenarios.length) {
            return scenarios.map(scenario => {
                const selectedFields = {
                    name: scenario.name,
                    environment: getEnvironmentShort(scenario.environment),
                    creationTime: moment(scenario.creationTime).fromNow().split(" ago")[0],
                    lastUpdateTime: moment(scenario.lastUpdateTime).fromNow()
                }
    
                return (
                    <Row 
                        key={scenario._id} 
                        data={selectedFields}
                        isActive={selectedScenario._id === scenario._id}
                        onClick={() => onClick(scenario._id)}
                        onEdit={() => onEdit(scenario._id)} 
                        onDelete={() => onDelete(scenario._id)} 
                    />
                )
            })
        }
    
        return <NoRecordsFound />
    }


    return (
        <table className="table">
            <thead className="test-instance-details-head">
                <tr>{ renderTableHeaders() }</tr>
            </thead>
            <tbody>
                { isLoading ? <LoadingSpinner /> : renderTableRows() }
            </tbody>
        </table>
    )
}

export default ScenariosList